/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".save-btn-popup[_ngcontent-%COMP%]{border-radius:2px;padding:4px 14px;margin:12px 0 0}.sales-call.alert-box[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{padding:18px 0}.f-w6[_ngcontent-%COMP%]{font-weight:600}.follow-up-border[_ngcontent-%COMP%]{border:1px solid #9fc2e8;margin-bottom:20px;padding:10px}.follow-up-border[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{padding:2px 4px}h4.modal-title[_ngcontent-%COMP%]{color:#2a9bd7}"];
export { styles as styles };
